module.exports = __webpack_public_path__ + "img/content8.21326303.png";